import { render, staticRenderFns } from "./CheckoutAutomation.vue?vue&type=template&id=1c748371&scoped=true"
import script from "./CheckoutAutomation.vue?vue&type=script&lang=js"
export * from "./CheckoutAutomation.vue?vue&type=script&lang=js"
import style0 from "./CheckoutAutomation.vue?vue&type=style&index=0&id=1c748371&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c748371",
  null
  
)

export default component.exports